export const reportStatuses = [
  { text: 'All reports', value: 'all' },
  { text: 'In Review', value: 'inReview' },
  { text: 'Approved', value: 'approved' },
  { text: 'Declined', value: 'declined' }
]

export const processBy = [
  { text: 'Human', value: 'human' },
  { text: 'System', value: 'system' },
  { text: 'AI', value: 'ai' }
]

export const processingStatuses = [
  { text: 'Approved', value: 'approved' },
  { text: 'Declined', value: 'declined' },
  { text: 'Closed', value: 'closed' },
  { text: 'Skipped', value: 'skipped' },
  { text: 'Failed', value: 'failed' },
  { text: 'Reassigned', value: 'reassigned' }
]

export const providerStatuses = [
  { text: 'Not requested', value: 'notRequested' },
  { text: 'Requested', value: 'requested' },
  { text: 'Approved', value: 'approved' },
  { text: 'Declined', value: 'declined' }
]
